import styled from 'styled-components/macro'
import { palette } from 'styled-tools'

export const StatusMessage = styled.div`
  color: ${palette('mountainMeadow')};
`

export default StatusMessage
